import React from "react";
import { ShieldCheck, ShieldAlert, ShieldX, Loader2, Tag, Shield } from "lucide-react";

export function authState(item = {}) {
  const claim = item.authenticity_claim || (item.brand ? "authentic" : "unbranded");
  const st = item.auth_status;
  if (claim === "replica")
    return { key: "replica", label: "Replica (disclosed)", color: "#EA580C", Icon: Tag };
  if (claim === "unbranded")
    return { key: "unbranded", label: "Unbranded / Inspired by", color: "#697169", Icon: Tag };
  if (st === "verified")
    return { key: "verified", label: "Verified authentic", color: "#16A34A", Icon: ShieldCheck };
  if (st === "screening")
    return { key: "screening", label: "Screening in progress", color: "#2563EB", Icon: Loader2 };
  if (st === "flagged")
    return { key: "flagged", label: "Brand claim unverified", color: "#EA580C", Icon: ShieldAlert };
  if (st === "rejected")
    return { key: "rejected", label: "Not authentic — delisted", color: "#E11D48", Icon: ShieldX };
  return { key: "unverified", label: "Unverified brand", color: "#697169", Icon: Shield };
}

export default function AuthBadge({ item, testid, compact = false }) {
  const s = authState(item);
  const Icon = s.Icon;
  return (
    <span
      data-testid={testid || `auth-badge-${s.key}`}
      data-auth-state={s.key}
      className={`inline-flex items-center gap-1.5 border uppercase tracking-[0.14em] whitespace-nowrap ${
        compact ? "px-1.5 py-0.5 text-[0.55rem]" : "px-2.5 py-1 text-[0.62rem]"
      }`}
      style={{ color: s.color, borderColor: s.color, background: "rgba(255,255,255,0.92)" }}
      title={s.label}
    >
      <Icon size={compact ? 10 : 12} className={s.key === "screening" ? "animate-spin" : ""} />
      {s.label}
    </span>
  );
}
